import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.scss";

import logo from "../../assets/image/Frame.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Scrollbar, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import { Switch, TextField, Button, Box, List, ListItem, colors } from "@mui/material";

import { MainContext } from "../../context/MainContext";

function Orders() {
  const { markers, action, ordersCurrent, ordersResolved } = useContext(MainContext);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  return (
    <div className={styles.main}>
      <div className={styles.objects__banner}>
        <div className={styles.objects__banner__content}>
          <img className={styles.objects__banner__logo} src={logo} alt="logo" />
          <div>
            <h3 className={styles.objects__banner__content_title}>FIRE SAFETY</h3>
            <p className={styles.objects__banner__content_text}>Center</p>
          </div>
        </div>
        <div className={styles.objects__profile}>
          <button className={styles.objects__profile__btn} onClick={() => navigate("/")}>
            Return
          </button>
        </div>
      </div>

      <div className={styles.orders__content}>
        <div className={styles.orders__content__title}>Заявки</div>
        <div className={styles.orders__content__open}>
          <Button
            variant="contained"
            onClick={() => {
              setOpen(!open);
            }}
            fullWidth
          >
            Добавить Заявку
          </Button>
        </div>
        <div className={styles.orders__content__slider}>
          <Swiper
            style={{
              height: "97%",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
            }}
            modules={[Pagination, Scrollbar, A11y]}
            spaceBetween={50}
            slidesPerView={1}
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={() => console.log("slide change")}
          >
            <SwiperSlide>
              <div style={{ color: "#fff", padding: "5px 10px" }}>
                Текущих заявок нет. Расслабьтесь парни
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div style={{ color: "#fff", padding: "5px 10px" }}>
                Здесь должныть быть отработанные заявки
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      <div
        className={`${styles.orders__content__menu} ${open ? styles.menuOpen : styles.menuClosed}`}
      >
        <div className={styles.menuInner}>Не тычь заявок нет и не будет пока не починят сервис</div>
      </div>
    </div>
  );
}

export default Orders;
